import { ArrowBack, ArrowLeft, AutoGraph, ChatRounded, Co2, ConnectingAirports, ConnectWithoutContact, ConnectWithoutContactOutlined, DataObject, Logout, Menu, Person, Podcasts, PriorityHighRounded } from '@mui/icons-material';
import { Button, Fab, Paper } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Stack } from '@mui/system';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Redirect, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import AppContextProvider from './AppContext';
import EmailVerification from './components/auth/EmailVerification';
import ForgotPassword from './components/auth/ForgotPassword';
import Login from './components/auth/Login';
import NewPassword from './components/auth/NewPassword';
import Register from './components/auth/Register';
import Content from './components/Content';
import Farmers from './components/farmers/Farmers';
import MapWrapper from './components/map/MapWrapper';
import Profile from './components/profile/Profile';
import Projects from './components/projects/Projects';
import RothC from './components/rothc/RothC';
import LoadingData from './components/widgets/LoadingData';
import $auth from './services/$auth';
import $cookies from './services/$cookies';
import { variables } from './styles/abstract/variables';
import './styles/main.scss';
import UserLabel from './components/ui/UserLabel';
import CarbonCalculator from './components/carbon-calculator/CarbonCalculator';
import CarbonReports from './components/carbon-calculator/CarbonReports';
import CarbonManagementSystem from './components/dms/CarbonManagementSystem';
import Header from './components/header/Header';
import CarbonParcel from './components/dms/CarbonParcel';
import CarbonAssessments from './components/carbon-assesments/CarbonAssessments';
import CarbonAssessmentInput from './components/carbon-assesments/CarbonAssessmentInput';

const theme = createTheme({
  palette: {
    primary: {
      main: variables.primary,
    },
    secondary: {
      main: variables.secondary
    },
    info: {
      main: variables.button,
      text: '#fff',
    },
    white: {
      main: "#fff",
    },
    blue: {
      main: '#3c73a8',
    },
    success: {
      main: '#5cb85c',
    }
  }
});


function App(props) {
  const timerRef = useRef(1800);
  const timerIntervalRef = useRef(null);

  const [state, setState] = useState({
    locale: props.locale,
    loggedIn: props.loggedIn,
    user: props.user,
    selected: null,
  });

  const setTimer = () => {
    if (timerIntervalRef.current) { clearInterval(timerIntervalRef.current) }
    timerRef.current = 1800;
    timerIntervalRef.current = setInterval(() => {

      timerRef.current -= 1;
      if (timerRef.current === 0) {
        $auth.refreshToken($cookies.get('refresh'))
          .then(token => { this.setTimer() })
          .catch(err => { window.location.reload() })
      }
    }, 1000)
  }

  const onVisibilityChange = () => {
    if ($cookies.get('refresh')) {
      $auth.refreshToken($cookies.get('refresh'))
        .then(token => {
          setTimer()
        })
        .catch(err => { window.location.reload(); })
    }

  }

  useEffect(() => {
    if (state.loggedIn) {
      setTimer();
    }

    document.addEventListener('visibilitychange', onVisibilityChange, false);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange, false);
    }
  }, []);

  useEffect(() => {
    if (state.loggedIn) {
      setTimer();
    } else {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current)
      }
    }
  }, [state.loggedIn])

  const [loading, setLoading] = useState({
    projects: false
  });

  const updateState = (newState) => {
    setState(current => ({ ...current, ...newState }));
  }

  const logout = async () => {
    try {
      await $auth.logout($cookies.get('refresh'));
      window.location.reload();

    } catch (e) {
      window.location.reload();

    }
  }


  const authCheck = (target, Fallback, props = {}) => {
    if (state.loggedIn) return <Redirect to={target} replace />

    if (Fallback.constructor === String) return <Redirect to={Fallback} replace />

    return <Fallback {...props} />
  }

  const userCheck = (user) => {
    if (!user) return '';

    return 'projects';
  }

  const isLoading = () => {
    if (loading.projects) return true;

    return false;
  }

  const isProjectSelected = () => {
    return window.location.pathname.indexOf('/dashboard/projects') == -1
      && window.location.pathname.indexOf('/dashboard/profile') == -1
      && window.location.pathname.indexOf('/dashboard/farmers') == -1
      && window.location.pathname.indexOf('/dashboard/soc-sequestration') == -1
  }

  let { locale, user, loggedIn, selected } = state;

  const location = useLocation();

  return (
    <AppContextProvider value={{ user, loggedIn, selected, onUpdateState: updateState }}>
      <ThemeProvider theme={theme}>
        <Switch location={location}>
          <Route exact path="/" render={() => authCheck(`/dashboard/${userCheck(state.user)}`, '/login')} />

          <Route exact path="/login" render={(props) => { return authCheck(`/dashboard/${userCheck(state.user)}`, Login, { onUpdateState: updateState }) }} />

          <Route exact path="/register" render={() => authCheck(`/dashboard/${userCheck(state.user)}`, Register)} />

          <Route exact path="/forgot-password" render={() => authCheck(`/dashboard/${userCheck(state.user)}`, ForgotPassword)} />

          <Route exact path="/email-verification/:id" render={(props) => authCheck(`/dashboard/${userCheck(state.user)}`, EmailVerification, { id: props.match.params.id })} />

          <Route exact path="/reset-password/:uid/:token" render={(props) => authCheck(`/dashboard/${userCheck(state.user)}`, NewPassword, { uid: props.match.params.uid, token: props.match.params.token })} />

          <Route path="/dashboard" render={(props) => {

            if (!loggedIn) return <Redirect to="/login" />

            if (window.location.pathname === '/dashboard' || window.location.pathname === '/dashboard/') return <Redirect to={`/dashboard/projects`} />;
            if (isLoading()) return <LoadingData />;

            let project = null;
            if (props.location.pathname.indexOf('/dashboard/project/') > -1) {
              project = props.location.pathname.split('/')[3];
            }

            return (
              <Content project={project}>

                <Header />
                <div style={{ height: '100%' }}>
                  <Route exact path="/dashboard/projects" render={(props) => {
                    return <Projects />
                  }} />

                  <Route exact path="/dashboard/profile" render={(props) => {
                    return <Profile />
                  }} />
                  {/* 
                  <Route exact path="/dashboard/farmers" render={(props) => {
                    return <Farmers />
                  }} /> */}

                  {/* <Route exact path="/dashboard/soc-sequestration" render={(props) => {
                    return <RothC />
                  }} /> */}

                  <Route exact path="/dashboard/carbon-emissions" render={(props) => {
                    return <CarbonReports />
                  }} />

                  <Route exact path="/dashboard/carbon-calculator/:id" render={(props) => {
                    let year = undefined;
                    let parcel = undefined;

                    if (props.match.params.id !== 'new') {
                      let parts = props.match.params.id.split('-');
                      parcel = parts[0];
                      year = parts[1];
                    }
                    return <CarbonCalculator year={year} parcel={parcel} id={props.match.params.id} />
                  }} />

                  <Route exact path="/dashboard/carbon-calculator/edit/:id" render={(props) => {
                    return <CarbonCalculator isEdit id={props.match.params.id} />
                  }} />

                  <Route exact path="/dashboard/project/:project/carbon-emissions" render={(props) => {
                    const projectId = props.match.params.project;
                    return <CarbonAssessments project={projectId} onUpdateState={updateState} />
                  }} />

                  <Route exact path="/dashboard/project/:project/carbon-emissions/:id/parcel/:parcel/year/:year" render={(props) => {
                    const projectId = props.match.params.project;
                    const id = props.match.params.id;
                    const year = props.match.params.year;
                    const parcel = props.match.params.parcel; 
                    return <CarbonAssessmentInput id={id} project={projectId} year={year} parcel={parcel} onUpdateState={updateState} />
                  }} />


                  <Route exact path="/dashboard/project/:project/carbon-management-system" render={(props) => {
                    const projectId = props.match.params.project;
                    return <CarbonManagementSystem project={projectId} onUpdateState={updateState} />
                  }} />

                  <Route exact path="/dashboard/carbon-management-parcel/:id/:year/" render={(props) => {
                    let parcelId = props.match.params.id;
                    let year = props.match.params.year
                    return <CarbonParcel id={parcelId} year={year} />
                  }} />

                  <Route exact path="/dashboard/project/:project/carbon-management-parcel/:id/:year/" render={(props) => {
                    let projectId = props.match.params.project;
                    let parcelId = props.match.params.id;
                    let year = props.match.params.year;

                    return <CarbonParcel id={parcelId} year={year} project={projectId} />
                  }} />


                  <Route exact path="/dashboard/project/:project/map/" render={(props) => {
                    return <MapWrapper project={props.match.params.project} />
                  }} />
                </div>

              </Content>
            )

          }} />

          <Route render={() => authCheck(`/dashboard/projects`, '/login')} />
        </Switch>
      </ThemeProvider>
    </AppContextProvider>
  );
}

export default App;
